import axios from "axios";
import { fetchingPropsI } from "./request/request.interface";
import { COOKIES_NAME } from "constants/appConstants";

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

export const sendGoogleLogin = async ({ params, signal }: fetchingPropsI) => {
  const uri = window.configs.REACT_APP_API + "auth/login-google";
  const response = await axios.post(uri, params);
  return response.data as AuthTokens;
};

export const refresh = async (refresh: string) => {
  const uri = window.configs.REACT_APP_API + "auth/refresh";
  const response = await axios.get(uri, {
    headers: {
      Authorization: `Bearer ${refresh}`,
      withCredentials: "true",
    },
  });
  return response.data as AuthTokens;
};

export const sendLogout = async () => {
  const uri = window.configs.REACT_APP_API + "auth/logout";
  const rawTokens = sessionStorage.getItem(COOKIES_NAME);
  const tokens: AuthTokens = rawTokens ? JSON.parse(rawTokens) : null;

  if (!tokens) {
    return;
  }

  return axios.post(
    uri,
    {},
    {
      headers: {
        Authorization: `Bearer ${tokens.refreshToken}`,
      },
    },
  );
};
